"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1253],{

/***/ 1253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EditSvg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(2951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(1318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
;// CONCATENATED MODULE: ./components/edit/Brushes.js
var brushes = [
    [
        [
            0,
            0
        ]
    ],
    [
        [
            0,
            0
        ]
    ],
    [
        [
            0,
            0
        ],
        [
            -5,
            -5
        ],
        [
            -5,
            -3
        ],
        [
            -5,
            -1
        ],
        [
            -5,
            1
        ],
        [
            -5,
            3
        ],
        [
            -4,
            0
        ],
        [
            -3,
            -5
        ],
        [
            -3,
            -3
        ],
        [
            -3,
            -1
        ],
        [
            -3,
            1
        ],
        [
            -3,
            3
        ],
        [
            -2,
            0
        ],
        [
            -3,
            -3
        ],
        [
            -3,
            -2
        ],
        [
            -3,
            -1
        ],
        [
            -3,
            0
        ],
        [
            -3,
            1
        ],
        [
            -3,
            2
        ],
        [
            -2,
            -3
        ],
        [
            -2,
            -2
        ],
        [
            -2,
            -1
        ],
        [
            -2,
            0
        ],
        [
            -2,
            1
        ],
        [
            -2,
            2
        ],
        [
            -1,
            -3
        ],
        [
            -1,
            -2
        ],
        [
            -1,
            -1
        ],
        [
            -1,
            0
        ],
        [
            -1,
            1
        ],
        [
            -1,
            2
        ],
        [
            0,
            -3
        ],
        [
            0,
            -2
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ],
        [
            0,
            2
        ],
        [
            1,
            -3
        ],
        [
            1,
            -2
        ],
        [
            1,
            -1
        ],
        [
            1,
            0
        ],
        [
            1,
            1
        ],
        [
            1,
            2
        ],
        [
            2,
            -3
        ],
        [
            2,
            -2
        ],
        [
            2,
            -1
        ],
        [
            2,
            0
        ],
        [
            2,
            1
        ],
        [
            2,
            2
        ],
        [
            3,
            0
        ],
        [
            3,
            1
        ],
        [
            3,
            2
        ],
        [
            3,
            3
        ],
        [
            1,
            1
        ],
        [
            1,
            3
        ],
        [
            2,
            0
        ],
        [
            3,
            -5
        ],
        [
            3,
            -3
        ],
        [
            3,
            -1
        ],
        [
            3,
            1
        ],
        [
            3,
            3
        ],
        [
            4,
            0
        ],
        [
            4,
            -5
        ],
        [
            5,
            0
        ],
        [
            5,
            -5
        ],
        [
            5,
            5
        ], 
    ],
    [
        [
            0,
            0
        ],
        [
            -10,
            -10
        ],
        [
            -10,
            -6
        ],
        [
            -10,
            -2
        ],
        [
            -10,
            2
        ],
        [
            -10,
            6
        ],
        [
            -6,
            -10
        ],
        [
            -6,
            -6
        ],
        [
            -6,
            -2
        ],
        [
            -6,
            2
        ],
        [
            -6,
            6
        ],
        [
            -2,
            -10
        ],
        [
            -2,
            -6
        ],
        [
            -2,
            -2
        ],
        [
            -3,
            -3
        ],
        [
            -3,
            -2
        ],
        [
            -3,
            -1
        ],
        [
            -3,
            0
        ],
        [
            -3,
            1
        ],
        [
            -3,
            2
        ],
        [
            -2,
            -3
        ],
        [
            -2,
            -2
        ],
        [
            -2,
            -1
        ],
        [
            -2,
            0
        ],
        [
            -2,
            1
        ],
        [
            -2,
            2
        ],
        [
            -1,
            -3
        ],
        [
            -1,
            -2
        ],
        [
            -1,
            -1
        ],
        [
            -1,
            0
        ],
        [
            -1,
            1
        ],
        [
            -1,
            2
        ],
        [
            0,
            -3
        ],
        [
            0,
            -2
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ],
        [
            0,
            2
        ],
        [
            1,
            -3
        ],
        [
            1,
            -2
        ],
        [
            1,
            -1
        ],
        [
            1,
            0
        ],
        [
            1,
            1
        ],
        [
            1,
            2
        ],
        [
            2,
            -3
        ],
        [
            2,
            -2
        ],
        [
            2,
            -1
        ],
        [
            2,
            0
        ],
        [
            2,
            1
        ],
        [
            2,
            2
        ],
        [
            3,
            0
        ],
        [
            3,
            1
        ],
        [
            3,
            2
        ],
        [
            3,
            3
        ],
        [
            -2,
            2
        ],
        [
            -2,
            6
        ],
        [
            2,
            -10
        ],
        [
            2,
            -6
        ],
        [
            2,
            -2
        ],
        [
            2,
            2
        ],
        [
            2,
            6
        ],
        [
            6,
            -10
        ],
        [
            6,
            -6
        ],
        [
            6,
            -2
        ],
        [
            6,
            2
        ],
        [
            6,
            6
        ],
        [
            10,
            10
        ],
        [
            10,
            0
        ],
        [
            10,
            -10
        ], 
    ], 
];
/* harmony default export */ var Brushes = (brushes);

;// CONCATENATED MODULE: ./components/edit/utils.js
function angle(cx, cy, ex, ey) {
    var dy = ey - cy;
    var dx = ex - cx;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]
    theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    return theta;
}
function angle360(cx, cy, ex, ey) {
    var theta = angle(cx, cy, ex, ey); // range (-180, 180]
    if (theta < 0) theta = 360 + theta; // range [0, 360)
    return theta;
}

// EXTERNAL MODULE: ./node_modules/quantize/quantize.js
var quantize = __webpack_require__(6243);
var quantize_default = /*#__PURE__*/__webpack_require__.n(quantize);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./components/edit/Editor.js












var Editor = /*#__PURE__*/ function() {
    "use strict";
    function Editor(param) {
        var target = param.target, image = param.image, svgUrl = param.svgUrl, svgData = param.svgData, onColorChanged = param.onColorChanged, onLoginNeeded = param.onLoginNeeded, onPremiumNeeded = param.onPremiumNeeded, onLoading = param.onLoading, onError = param.onError, doneInit = param.doneInit, _removeBackgroundOnInit = param.removeBackgroundOnInit, removeBackgroundOnInit = _removeBackgroundOnInit === void 0 ? false : _removeBackgroundOnInit, checkRemoveBackgroundInProgress = param.checkRemoveBackgroundInProgress, setRemoveBackgroundInProgress = param.setRemoveBackgroundInProgress;
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, Editor);
        (0,_define_property/* default */.Z)(this, "focusedPaths", []);
        (0,_define_property/* default */.Z)(this, "selectedPaths", []);
        (0,_define_property/* default */.Z)(this, "currentActionBatch", []);
        (0,_define_property/* default */.Z)(this, "undoStack", []);
        (0,_define_property/* default */.Z)(this, "redoStack", []);
        (0,_define_property/* default */.Z)(this, "overlaySvg", null);
        (0,_define_property/* default */.Z)(this, "currentLine", null);
        (0,_define_property/* default */.Z)(this, "originalColors", {});
        (0,_define_property/* default */.Z)(this, "colorPallettes", {});
        (0,_define_property/* default */.Z)(this, "uniqueColors", []);
        (0,_define_property/* default */.Z)(this, "removeBackgroundOnInit", false);
        // console.log("Editor constructor");
        this.target = target;
        this.image = image;
        this.brushSize = 1;
        this.brushColor = "#7928CA";
        this.mode = "fill";
        this.onColorChanged = onColorChanged;
        this.onLoginNeeded = onLoginNeeded;
        this.onPremiumNeeded = onPremiumNeeded;
        this.onLoading = onLoading;
        this.onError = onError;
        this.isLoading = false;
        this.removeBackgroundOnInit = removeBackgroundOnInit;
        this.checkRemoveBackgroundInProgress = checkRemoveBackgroundInProgress;
        this.setRemoveBackgroundInProgress = setRemoveBackgroundInProgress;
        if (svgData) {
            this.target.innerHTML = svgData;
            this.svgEl = this.target.getElementsByTagName("svg")[0];
            this.init().then(function() {
                if (_this.removeBackgroundOnInit) {
                    _this.removeBackground();
                }
                doneInit();
            });
        } else {
            axios/* default.get */.Z.get(svgUrl).then(function(response) {
                _this.target.innerHTML = response.data;
                _this.svgEl = _this.target.getElementsByTagName("svg")[0];
                return _this.init().then(function() {
                    if (_this.removeBackgroundOnInit) {
                        _this.removeBackground();
                    }
                    doneInit();
                });
            }).catch(function(err) {
                axios/* default.get */.Z.get("https://my.vectorart.ai/storage/v1/object/public/vectorart-upload/".concat(svgUrl.split("/").slice(-2)[0])).then(function(response) {
                    _this.target.innerHTML = response.data;
                    _this.svgEl = _this.target.getElementsByTagName("svg")[0];
                    return _this.init().then(function() {
                        if (_this.removeBackgroundOnInit) {
                            _this.removeBackground();
                        }
                        doneInit();
                    });
                });
            });
        }
    }
    (0,_create_class/* default */.Z)(Editor, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, paths, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, p;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(/* import() */[__webpack_require__.e(5195), __webpack_require__.e(9772), __webpack_require__.e(9162)]).then(__webpack_require__.t.bind(__webpack_require__, 3267, 23))
                                ];
                            case 1:
                                _this.paper = _state.sent().default;
                                _this.paper.setup(_this.svgEl);
                                _this.paper.project.importSVG(_this.svgEl);
                                _this.target.style.position = "relative";
                                _this.overlaySvg = document.createElement("div");
                                _this.overlaySvg.style.position = "absolute";
                                _this.overlaySvg.style.top = 0;
                                _this.overlaySvg.style.left = 0;
                                _this.overlaySvg.style.pointerEvents = "none";
                                _this.overlaySvg.style.width = "100%";
                                _this.overlaySvg.style.height = "100%";
                                _this.target.appendChild(_this.overlaySvg);
                                _this.overlaySvg.innerHTML = '<svg height="100%" width="100%">\n        <line x1="0" y1="0" x2="200" y2="200" style="display:none;fill:black;stroke:#ffffff;stroke-width:2;stroke-linecap: round;" />\n      </svg>';
                                paths = (ref = _this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                                i = 0;
                                _this.paper.project.getItems({
                                    class: _this.paper.Path
                                }).forEach(function(path, i) {
                                    path.name = "path-".concat(i);
                                });
                                _this.svgEl.onmouseleave = _this.svgEl.ontouchcancel = function(evt) {
                                    if (_this.currentLine) {
                                        _this.currentLine.style.display = "none";
                                    }
                                    _this.focusedPaths = [];
                                    _this.currentActionBatch = [];
                                };
                                _this.svgEl.onmouseup = _this.svgEl.ontouchend = function(evt) {
                                    // console.log("mouseup", this.currentActionBatch.length);
                                    if (_this.currentLine) {
                                        _this.currentLine.style.display = "none";
                                    }
                                    if (_this.currentActionBatch.length) {
                                        if (_this.mode === "gradient") {
                                            _this.currentActionBatch[0].endPos = {
                                                x: evt.clientX,
                                                y: evt.clientY
                                            };
                                            _this.currentActionBatch[0].endOffset = {
                                                x: evt.offsetX,
                                                y: evt.offsetY
                                            };
                                            _this.performAction(null, "gradient", null, _this.currentActionBatch[0]);
                                        }
                                        _this.undoStack.push(_this.currentActionBatch);
                                        _this.redoStack = [];
                                        _this.currentActionBatch = [];
                                    }
                                    _this.focusedPaths = [];
                                };
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = paths[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        p = _step.value;
                                        p.dataset.index = i;
                                        _this.registerPathEvents(p, paths);
                                        i++;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "registerPathEvents",
            value: function registerPathEvents(p, paths) {
                var _this = this;
                p.onmousedown = p.ontouchstart = function(evt) {
                    _this.currentActionBatch = [];
                    var list = _this.pathsForPoint(evt);
                    if (_this.mode === "gradient") {
                        _this.currentActionBatch.push({
                            action: "gradient",
                            startPos: {
                                x: evt.clientX,
                                y: evt.clientY
                            },
                            startOffset: {
                                x: evt.offsetX,
                                y: evt.offsetY
                            },
                            index: list[0].dataset.index,
                            from: p.dataset.index,
                            to: p.dataset.index,
                            selectedPaths: list.map(function(path) {
                                return path.dataset.index;
                            })
                        });
                        return;
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var path = _step.value;
                            var action = _this.performAction(path, _this.mode, _this.brushColor);
                            // console.log("action", action);
                            if (action) {
                                _this.currentActionBatch.push(action);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                p.onmousemove = p.ontouchmove = function(evt) {
                    var ref;
                    if (_this.mode !== "gradient") {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _this.focusedPaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var index = _step.value;
                                paths[index].style.opacity = 1.0;
                                paths[index].style.stroke = null;
                                paths[index].style.strokeWidth = null;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _this.focusedPaths = [];
                    }
                    var list = _this.pathsForPoint(evt);
                    if (evt.buttons || ((ref = evt.touches) === null || ref === void 0 ? void 0 : ref.length)) {
                        if (_this.mode === "gradient") {
                            _this.drawLine(evt);
                            if (_this.currentActionBatch.length === 1) {
                                _this.currentActionBatch[0].selectedPaths = lodash_default().uniq((0,_to_consumable_array/* default */.Z)(_this.currentActionBatch[0].selectedPaths).concat((0,_to_consumable_array/* default */.Z)(list.map(function(path) {
                                    return path.dataset.index;
                                }))));
                                _this.currentActionBatch[0].to = list[0].dataset.index;
                            }
                            return;
                        } else if (_this.mode === "selection") {
                            _this.selectedPaths = lodash_default().uniq((0,_to_consumable_array/* default */.Z)(_this.selectedPaths).concat((0,_to_consumable_array/* default */.Z)(list.map(function(path) {
                                return path.dataset.index;
                            }))));
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = list[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var path = _step1.value;
                                var action = _this.performAction(path, _this.mode, _this.brushColor);
                                // console.log("action", action);
                                if (action) {
                                    _this.currentActionBatch.push(action);
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    } else if (_this.mode === "fill" || _this.mode === "erase") {
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = _this.focusedPaths[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var index1 = _step2.value;
                                var target = paths[index1];
                                target.style.stroke = null;
                                target.style.strokeWidth = null;
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        _this.focusedPaths = [];
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        try {
                            for(var _iterator3 = list[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                var target1 = _step3.value;
                                target1.style.strokeWidth = "2px";
                                target1.style.stroke = "#0D99FF";
                                _this.focusedPaths.push(target1.dataset.index);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                };
                p.onmouseleave = p.ontouchcancel = function(evt) {
                    evt.target.style.opacity = 1.0;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this.focusedPaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var index = _step.value;
                            var target = paths[index];
                            target.style.stroke = null;
                            target.style.strokeWidth = null;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                p.onclick = function(evt) {
                    _this.currentActionBatch = [];
                    _this.selectedPaths = [];
                    var path = evt.target;
                    var pathIndex = path.dataset.index;
                    // console.log("click!", evt, i, pathIndex);
                    if (_this.mode === "gradient") {
                        return;
                    }
                    var action = _this.performAction(path, _this.mode, _this.brushColor);
                    if (action) {
                        _this.undoStack.push([
                            action
                        ]);
                        _this.redoStack = [];
                    }
                    if (_this.mode === "selection") {
                        if (_this.selectedPaths.length && !_this.selectedPaths.includes(pathIndex)) {
                            _this.selectedPaths = [];
                            _this.updateSelection();
                        } else if (!_this.selectedPaths.length) {
                            _this.selectedPaths.push(pathIndex);
                            _this.updateSelection();
                        }
                    }
                };
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var ref;
                var paths = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.selectedPaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var selectedPath = _step.value;
                        var pathCopy = paths[selectedPath].cloneNode(true);
                        pathCopy.classList.add("selected-path");
                        this.overlaySvg.getElementsByTagName("svg")[0].appendChild(pathCopy);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "normalizeColor",
            value: function normalizeColor(color) {
                if (color === null || color === void 0 ? void 0 : color.startsWith("#")) {
                    return color;
                }
                if (color === null || color === void 0 ? void 0 : color.startsWith("rgb")) {
                    var ref = (0,_sliced_to_array/* default */.Z)(color.substring(4, color.length - 1).split(",").map(function(x) {
                        return parseInt(x);
                    }), 3), r = ref[0], g = ref[1], b = ref[2];
                    var sr = r.toString(16);
                    if (sr.length === 1) {
                        sr = "0" + sr;
                    }
                    var sg = g.toString(16);
                    if (sg.length === 1) {
                        sg = "0" + sg;
                    }
                    var sb = b.toString(16);
                    if (sb.length === 1) {
                        sb = "0" + sb;
                    }
                    return "#".concat(sr).concat(sg).concat(sb);
                }
                return null;
            }
        },
        {
            key: "drawLine",
            value: function drawLine(evt) {
                if (!this.currentActionBatch[0]) {
                    return;
                }
                if (!this.currentLine) {
                    this.currentLine = this.overlaySvg.getElementsByTagName("line")[0];
                }
                this.currentLine.style.display = "block";
                this.currentLine.setAttribute("x1", this.currentActionBatch[0].startOffset.x);
                this.currentLine.setAttribute("y1", this.currentActionBatch[0].startOffset.y);
                this.currentLine.setAttribute("x2", evt.offsetX);
                this.currentLine.setAttribute("y2", evt.offsetY);
            }
        },
        {
            key: "hexToRgb",
            value: function hexToRgb(hex) {
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? [
                    parseInt(result[1], 16),
                    parseInt(result[2], 16),
                    parseInt(result[3], 16), 
                ] : null;
            }
        },
        {
            key: "componentToHex",
            value: function componentToHex(c) {
                var hex = c.toString(16);
                return hex.length == 1 ? "0" + hex : hex;
            }
        },
        {
            key: "rgbToHex",
            value: function rgbToHex(r, g, b) {
                return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
            }
        },
        {
            key: "pathColor",
            value: function pathColor(path) {
                return this.normalizeColor(path.style.fill || path.style.stroke || path.getAttribute("fill") || path.getAttribute("stroke"));
            }
        },
        {
            key: "pathColors",
            value: function pathColors(path) {
                var strokeColor = path.getAttribute("stroke");
                var gradientMatch = strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.match(/url\(#grad-(\d+)\)/);
                if (gradientMatch) {
                    var ref;
                    var gradientIndex = gradientMatch[1];
                    var gradient = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.querySelector("#grad-".concat(gradientIndex));
                    var stops = gradient.querySelectorAll("stop");
                    return Array.from(stops).map(function(stop) {
                        return stop.getAttribute("stop-color");
                    });
                }
                return [
                    this.pathColor(path)
                ];
            }
        },
        {
            key: "performAction",
            value: function performAction(path, mode, color, action) {
                var ref, ref1;
                var result = {};
                if (mode === "gradient") {
                    return this.applyGradient(action);
                } else if (mode === "ungradient") {
                    return this.removeGradient(action);
                } else if (mode === "unungradient") {
                    return this.reapplyGradient(action);
                } else if (mode === "fill") {
                    var normalizedColor = this.normalizeColor(color);
                    result = {
                        index: path.dataset.index,
                        action: "fill",
                        from: this.normalizeColor(path.style.fill),
                        to: normalizedColor
                    };
                    path.style.visibility = "visible";
                    path.style.fill = normalizedColor;
                    path.style.stroke = normalizedColor;
                } else if (mode === "erase") {
                    result = {
                        index: path.dataset.index,
                        action: "erase",
                        from: path.style.visibility,
                        to: "hidden"
                    };
                    path.style.visibility = "hidden";
                } else if (mode === "draw") {
                    result = {
                        index: path.dataset.index,
                        action: "draw",
                        from: path.style.visibility,
                        to: "visible"
                    };
                    path.style.visibility = "visible";
                } else if (mode === "eyedropper") {
                    var _$color = this.pathColor(path);
                    // console.log(color, path.style.fill);
                    this.onColorChanged(_$color);
                }
                if (((ref = result.from) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === ((ref1 = result.to) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase())) {
                    return null;
                }
                return result;
            }
        },
        {
            key: "pathsForPoint",
            value: function pathsForPoint(evt) {
                var ref, ref1;
                var x = evt.clientX || ((ref = evt.touches) === null || ref === void 0 ? void 0 : ref[0].clientX);
                var y = evt.clientY || ((ref1 = evt.touches) === null || ref1 === void 0 ? void 0 : ref1[0].clientY);
                var deltas = Brushes[this.brushSize];
                var result = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = deltas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var delta = _step.value;
                        var element = document.elementFromPoint(x + this.brushSize * delta[0], y + this.brushSize * delta[1]);
                        if (element && element.tagName === "path") {
                            result.push(element);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "applyGradient",
            value: function applyGradient(action) {
                var _this = this;
                var ref, ref1;
                var paths = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = action.selectedPaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pathIndex = _step.value;
                        paths[pathIndex].style.opacity = 1.0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.currentActionBatch.length !== 1) {
                    return;
                }
                if (!action.to || action.from === action.to) {
                    return;
                }
                var uniqSelectedPaths = lodash_default().uniq(action.selectedPaths).map(function(pathIndex) {
                    return parseInt(pathIndex);
                });
                var selectedPaperPaths = uniqSelectedPaths.map(function(pathIndex) {
                    return _this.paper.project.activeLayer.children[0].children["path-".concat(pathIndex)];
                });
                var svgPaths = uniqSelectedPaths.map(function(pathIndex) {
                    return paths[pathIndex];
                });
                var unitedPath = new this.paper.Path({
                    insert: false
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = selectedPaperPaths[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var path = _step1.value;
                        unitedPath = unitedPath.unite(path, {
                            insert: false
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var newPath = unitedPath.exportSVG();
                this.svgEl.appendChild(newPath);
                this.paper.project.activeLayer.children[0].addChild(unitedPath);
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = uniqSelectedPaths[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var pathIndex1 = _step2.value;
                        paths[pathIndex1].style.display = "none";
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                var newPaths = (ref1 = this.svgEl) === null || ref1 === void 0 ? void 0 : ref1.getElementsByTagName("path");
                newPath.dataset.index = newPaths.length - 1;
                action.newIndex = newPath.dataset.index;
                unitedPath.name = "path-".concat(action.newIndex);
                this.registerPathEvents(newPath, newPaths);
                var gradientChild = document.createElement("defs");
                newPath.setAttribute("fill", "url(#grad-".concat(newPath.dataset.index, ")"));
                newPath.setAttribute("stroke", "url(#grad-".concat(newPath.dataset.index, ")"));
                newPath.setAttribute("stroke-width", "0.25");
                this.svgEl.insertBefore(gradientChild, this.svgEl.firstChild);
                var angle = angle360(action.startPos.x, action.startPos.y, action.endPos.x, action.endPos.y);
                // console.log(angle);
                // for (const pp of svgPaths) {
                //     console.log(pp.dataset.index, pp.getAttribute("fill"));
                // }
                //TODO intersect paths
                //TODO toolbar labels
                //TODO better hover effect
                var colors = [];
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = svgPaths[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var path1 = _step3.value;
                        var // console.log(pathColors);
                        _colors;
                        if (!path1) {
                            continue;
                        }
                        var pathColors = this.pathColors(path1);
                        (_colors = colors).push.apply(_colors, (0,_to_consumable_array/* default */.Z)(pathColors));
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                gradientChild.outerHTML = '<defs>\n                <linearGradient id="grad-'.concat(newPath.dataset.index, '" gradientTransform="rotate(').concat(angle.toFixed(0), ' 0.5 0.5)">\n                ').concat(colors.map(function(color, i) {
                    return '\n                        <stop\n                            stop-color="'.concat(color, '"\n                            offset="').concat(i / colors.length, '"\n                        />\n                    ');
                }), "\n                </linearGradient>\n          </defs>");
            }
        },
        {
            key: "removeGradient",
            value: function removeGradient(action) {
                var ref;
                var paths = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = action.selectedPaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pathIndex = _step.value;
                        if (paths[pathIndex]) {
                            paths[pathIndex].style.display = "block";
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (paths[action.newIndex]) {
                    paths[action.newIndex].style.display = "none";
                }
            }
        },
        {
            key: "reapplyGradient",
            value: function reapplyGradient(action) {
                var ref;
                var paths = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                if (paths[action.newIndex]) {
                    paths[action.newIndex].style.display = "block";
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = action.selectedPaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pathIndex = _step.value;
                        if (paths[pathIndex]) {
                            paths[pathIndex].style.display = "none";
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "setBrushSize",
            value: function setBrushSize(size) {
                ;
                this.brushSize = size;
            }
        },
        {
            key: "setBrushColor",
            value: function setBrushColor(color) {
                ;
                this.brushColor = color;
            }
        },
        {
            key: "setMode",
            value: function setMode(mode) {
                ;
                this.mode = mode;
            }
        },
        {
            key: "undo",
            value: function undo() {
                var ref;
                ;
                if (!this.undoStack.length) {
                    ;
                    return;
                }
                var paths = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                var actions = this.undoStack.pop();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var action = _step.value;
                        // console.log("undo", action);
                        this.performAction(paths[action.index], action.action === "erase" ? "draw" : action.action === "gradient" ? "ungradient" : action.action, action.from, action);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.redoStack.push(actions);
            }
        },
        {
            key: "redo",
            value: function redo() {
                var ref;
                ;
                if (!this.redoStack.length) {
                    ;
                    return;
                }
                var paths = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                var actions = this.redoStack.pop();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var action = _step.value;
                        // console.log("redo", action);
                        this.performAction(paths[action.index], action.action === "gradient" ? "unungradient" : action.action, action.to, action);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.undoStack.push(actions);
            }
        },
        {
            key: "download",
            value: function download() {
                var ref;
                ;
                var svg = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.cloneNode(true);
                var paths = svg.getElementsByTagName("path");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var path = _step.value;
                        if (path.style.visibility === "hidden") {
                            path.remove();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var svgData = svg.outerHTML;
                var svgBlob = new Blob([
                    svgData
                ], {
                    type: "image/svg+xml;charset=utf-8"
                });
                var svgUrl = URL.createObjectURL(svgBlob);
                var downloadLink = document.createElement("a");
                downloadLink.href = svgUrl;
                downloadLink.download = "image.svg";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
        },
        {
            key: "removeBackground",
            value: function removeBackground() {
                var _this = this;
                ;
                // Check if there's already a remove background operation in progress
                if (this.checkRemoveBackgroundInProgress) {
                    var existingPromise = this.checkRemoveBackgroundInProgress();
                    if (existingPromise) {
                        ;
                        return existingPromise;
                    }
                }
                if (this.isLoading) {
                    return;
                }
                this.isLoading = true;
                this.onLoading(true);
                var promise;
                if (!this.image) {
                    var ref;
                    var svg = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.cloneNode(true);
                    var paths = svg.getElementsByTagName("path");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var path = _step.value;
                            if (path.style.visibility === "hidden") {
                                path.remove();
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var svgData = svg.outerHTML;
                    promise = axios/* default.post */.Z.post("/api/image/generic/remove-background", svgData, {
                        headers: {
                            "Content-Type": "image/svg+xml"
                        }
                    }).then(function(response) {
                        var ref;
                        var actions = [];
                        var indexes = response.data.indexes;
                        var paths = (ref = _this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = indexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var index = _step.value;
                                var path = paths[index];
                                path.style.visibility = "hidden";
                                actions.push({
                                    index: path.dataset.index,
                                    action: "erase",
                                    from: path.style.visibility,
                                    to: "hidden"
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _this.undoStack.push(actions);
                    }).catch(function(err) {
                        var ref, ref1;
                        if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 400) {
                            var _obj, ref2;
                            (ref2 = (_obj = _this).onLoginNeeded) === null || ref2 === void 0 ? void 0 : ref2.call(_obj);
                        } else if ((err === null || err === void 0 ? void 0 : (ref1 = err.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                            var _obj1, ref3;
                            (ref3 = (_obj1 = _this).onPremiumNeeded) === null || ref3 === void 0 ? void 0 : ref3.call(_obj1);
                        } else {
                            var ref4, ref5, _obj2, ref6;
                            (ref6 = (_obj2 = _this).onError) === null || ref6 === void 0 ? void 0 : ref6.call(_obj2, (err === null || err === void 0 ? void 0 : (ref4 = err.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.error) || (err === null || err === void 0 ? void 0 : err.message) || "Failed to remove background. Please try again.");
                        }
                    }).finally(function() {
                        _this.isLoading = false;
                        _this.onLoading(false);
                        if (_this.setRemoveBackgroundInProgress) {
                            _this.setRemoveBackgroundInProgress(false, null);
                        }
                    });
                } else {
                    promise = axios/* default.post */.Z.post("/api/image/".concat(this.image, "/remove-background")).then(function(response) {
                        var ref;
                        var actions = [];
                        var indexes = response.data.indexes;
                        var paths = (ref = _this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = indexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var index = _step.value;
                                var path = paths[index];
                                path.style.visibility = "hidden";
                                actions.push({
                                    index: path.dataset.index,
                                    action: "erase",
                                    from: path.style.visibility,
                                    to: "hidden"
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _this.undoStack.push(actions);
                    }).catch(function(err) {
                        var ref, ref1;
                        if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 400) {
                            var _obj, ref2;
                            (ref2 = (_obj = _this).onLoginNeeded) === null || ref2 === void 0 ? void 0 : ref2.call(_obj);
                        } else if ((err === null || err === void 0 ? void 0 : (ref1 = err.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                            var _obj1, ref3;
                            (ref3 = (_obj1 = _this).onPremiumNeeded) === null || ref3 === void 0 ? void 0 : ref3.call(_obj1);
                        } else {
                            var ref4, ref5, _obj2, ref6;
                            (ref6 = (_obj2 = _this).onError) === null || ref6 === void 0 ? void 0 : ref6.call(_obj2, (err === null || err === void 0 ? void 0 : (ref4 = err.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.error) || (err === null || err === void 0 ? void 0 : err.message) || "Failed to remove background. Please try again.");
                        }
                    }).finally(function() {
                        _this.isLoading = false;
                        _this.onLoading(false);
                        if (_this.setRemoveBackgroundInProgress) {
                            _this.setRemoveBackgroundInProgress(false, null);
                        }
                    });
                }
                // Store the promise in shared state to prevent duplicate calls
                if (this.setRemoveBackgroundInProgress) {
                    this.setRemoveBackgroundInProgress(true, promise);
                }
                return promise;
            }
        },
        {
            key: "quantizeColors",
            value: function quantizeColors(factor) {
                var _this = this;
                var ref;
                var paths = (ref = this.svgEl) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("path");
                if (factor >= 1 && this.originalColors) {
                    ;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var path = _step.value;
                            var pathColor = this.originalColors[path.dataset.index];
                            if (!pathColor) {
                                continue;
                            }
                            path.style.fill = pathColor;
                            path.style.stroke = pathColor;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return;
                }
                var colors = (this.uniqueColors || []).map(function(color) {
                    return _this.hexToRgb(color);
                });
                if (!colors.length) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = paths[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var path1 = _step1.value;
                            var pathColor1 = this.pathColor(path1);
                            if (!pathColor1) {
                                continue;
                            }
                            colors.push(this.hexToRgb(pathColor1));
                            this.originalColors[path1.dataset.index] = pathColor1;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    this.uniqueColors = lodash_default().uniq(Object.values(this.originalColors));
                }
                var numColors = Math.max(2, parseInt(factor * Math.min(32, this.uniqueColors.length)));
                ;
                var palette = this.colorPallettes[factor] || quantize_default()(colors, numColors);
                this.colorPallettes[factor] = palette;
                var actions = [];
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = paths[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var path2 = _step2.value;
                        var pathColor2 = this.originalColors[path2.dataset.index];
                        if (!pathColor2) {
                            continue;
                        }
                        var newColor = this.rgbToHex.apply(this, (0,_to_consumable_array/* default */.Z)(palette.nearest(this.hexToRgb(pathColor2))));
                        actions.push({
                            index: path2.dataset.index,
                            action: "fill",
                            from: this.normalizeColor(path2.style.fill),
                            to: newColor
                        });
                        path2.style.fill = newColor;
                        path2.style.stroke = newColor;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                this.undoStack.push(actions);
            }
        }
    ]);
    return Editor;
}();


// EXTERNAL MODULE: ./components/Spinner.js
var Spinner = __webpack_require__(6746);
;// CONCATENATED MODULE: ./components/edit/CanvasSvg.js








// Shared state to prevent duplicate remove background calls across component remounts
var removeBackgroundInProgress = false;
var removeBackgroundPromise = null;
var CanvasSvg = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CanvasSvg, _Component);
    var _super = (0,_create_super/* default */.Z)(CanvasSvg);
    function CanvasSvg(props) {
        (0,_class_call_check/* default */.Z)(this, CanvasSvg);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            loading: true
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(CanvasSvg, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                if (this.el) {
                    var ref, ref1;
                    this.node = document.createElement("div");
                    this.el.appendChild(this.node);
                    this.editor = new Editor({
                        target: this.node,
                        image: this.props.image,
                        svgData: this.props.svgData,
                        svgUrl: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/".concat(this.props.image, "/sm"),
                        removeBackgroundOnInit: this.props.removeBackgroundOnInit,
                        onColorChanged: this.props.onColorChanged,
                        onLoginNeeded: this.props.onLoginNeeded,
                        onPremiumNeeded: this.props.onPremiumNeeded,
                        onError: this.props.onError,
                        onLoading: function(isLoading) {
                            _this.props.onLoading({
                                loading: isLoading
                            });
                        },
                        doneInit: function() {
                            _this.setState({
                                loading: false
                            });
                            _this.props.onDoneInit();
                        },
                        checkRemoveBackgroundInProgress: function() {
                            if (removeBackgroundInProgress && removeBackgroundPromise) {
                                return removeBackgroundPromise;
                            }
                            return null;
                        },
                        setRemoveBackgroundInProgress: function(inProgress) {
                            var promise = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                            removeBackgroundInProgress = inProgress;
                            removeBackgroundPromise = promise;
                        }
                    });
                    (ref = this.props) === null || ref === void 0 ? void 0 : (ref1 = ref.onEditorReady) === null || ref1 === void 0 ? void 0 : ref1.call(ref, this.editor);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                ;
                if (prevProps.brushSize !== this.props.brushSize) {
                    this.editor.setBrushSize(this.props.brushSize);
                }
                if (prevProps.brushColor !== this.props.brushColor) {
                    this.editor.setBrushColor(this.props.brushColor);
                }
                if (prevProps.mode !== this.props.mode) {
                    this.editor.setMode(this.props.mode);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.node.remove();
                if (this.editor) {
                    this.editor.onColorChanged = null;
                    this.editor = null;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: this.props.className,
                    ref: function(el) {
                        return _this.el = el;
                    },
                    children: this.state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex justify-center align-middle items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "self-center flex items-center justify-center",
                            style: {
                                width: 512,
                                height: 512
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                                className: "w-16 h-16"
                            })
                        })
                    }) : null
                }, "svg-wrapper");
            }
        }
    ]);
    return CanvasSvg;
}(react.Component);


// EXTERNAL MODULE: ./components/edit/Toolbar.js
var Toolbar = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(1355);
;// CONCATENATED MODULE: ./components/edit/ColorLimitBar.js



function ColorLimitBar(param) {
    var show = param.show, colorLimit = param.colorLimit, setColorLimit = param.setColorLimit, editor = param.editor, setShowColorLimitBar = param.setShowColorLimitBar;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: show,
        style: {
            left: "calc(50% - 205px)",
            bottom: 160
        },
        className: "absolute z-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
            className: "",
            enter: "transition-all ease-in-out duration-200",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "transition-all ease-in-out duration-300",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* ToolbarSection */.Z2, {
                className: "p-4 bg-black backdrop-blur-sm bg-opacity-70 flex flex-col rounded-xl relative sm:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return setShowColorLimitBar(false);
                        },
                        className: "absolute top-2 right-2 text-white hover:text-gray-300 focus:outline-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-4 w-4",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2,
                                d: "M6 18L18 6M6 6l12 12"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "default-range",
                        className: "mx-4 block mb-4 text-sm font-medium text-white",
                        children: "Reduce colors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        onBlur: function() {
                            return setShowColorLimitBar(false);
                        },
                        onChange: function(e) {
                            setColorLimit(e.target.value);
                            editor === null || editor === void 0 ? void 0 : editor.quantizeColors(e.target.value / 10.0);
                        },
                        id: "default-range",
                        type: "range",
                        step: 1,
                        defaultValue: colorLimit,
                        min: 0,
                        max: 10,
                        className: "mx-8 w-full bg-gray-200 rounded-lg appearance-none cursor-pointer"
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/edit/EditSvg.js





 // Add this import
function EditSvg(props) {
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), processLoading = ref1[0], setProcessLoading = ref1[1];
    var ref2 = (0,react.useState)(), editor = ref2[0], setEditor = ref2[1];
    var ref3 = (0,react.useState)("fill"), mode = ref3[0], setMode = ref3[1];
    var ref4 = (0,react.useState)(1), brushSize = ref4[0], setBrushSize = ref4[1];
    var ref5 = (0,react.useState)("#7928CA"), brushColor = ref5[0], setBrushColor = ref5[1];
    var ref6 = (0,react.useState)(false), showColorLimitBar = ref6[0], setShowColorLimitBar = ref6[1];
    var ref7 = (0,react.useState)(10), colorLimit = ref7[0], setColorLimit = ref7[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto relative flex w-full h-full flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden w-28 mr-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col items-center justify-center"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-hidden flex  justify-center h-full canvas-mode-".concat(mode, " canvas-brush-").concat(brushSize),
                children: [
                    !props.children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CanvasSvg, {
                            image: props.image,
                            svgData: props.svgData,
                            mode: mode,
                            brushSize: brushSize,
                            brushColor: brushColor,
                            removeBackgroundOnInit: props.removeBackgroundOnInit,
                            onColorChanged: function(color) {
                                return setBrushColor(color);
                            },
                            onLoginNeeded: props.onLoginNeeded,
                            onPremiumNeeded: props.onPremiumNeeded,
                            onError: props.onError,
                            onLoading: function(param) {
                                var loading = param.loading;
                                setProcessLoading(loading);
                            },
                            onEditorReady: function(editor) {
                                return setEditor(editor);
                            },
                            className: "mx-auto h-full relative [&>*>svg]:w-full [&>*>svg]:h-full [&>div]:w-full [&>div]:h-full " + (loading ? "" : "image-display ") + (props.children ? "opacity-0" : "") + (processLoading ? "opacity-40 " : ""),
                            onDoneInit: function() {
                                return setLoading(false);
                            }
                        }, "canvas")
                    }),
                    props.children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inset-0 flex right-32",
                        children: props.children
                    }),
                    processLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-16 h-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorLimitBar, {
                        show: showColorLimitBar,
                        colorLimit: colorLimit,
                        setColorLimit: setColorLimit,
                        editor: editor,
                        setShowColorLimitBar: setShowColorLimitBar
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-3 flex justify-center",
                    children: (editor || props.children && props.showToolbar) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.ZP, {
                        isSubscribed: props.isSubscribed,
                        enabled: !processLoading && !props.children,
                        mode: mode,
                        brushSize: brushSize,
                        brushColor: brushColor,
                        setBrushSize: function(brushSize) {
                            return setBrushSize(brushSize);
                        },
                        setBrushColor: function(color) {
                            return setBrushColor(color);
                        },
                        setMode: function(mode) {
                            return setMode(mode);
                        },
                        showColorLimitBar: showColorLimitBar,
                        setShowColorLimitBar: function(val) {
                            setShowColorLimitBar(val);
                        },
                        clearTooltip: function() {
                            return setShowTooltip(false);
                        },
                        removeBackground: function() {
                            return editor === null || editor === void 0 ? void 0 : editor.removeBackground();
                        },
                        quantizeColors: function(numColors) {
                            return editor === null || editor === void 0 ? void 0 : editor.quantizeColors(numColors);
                        },
                        undo: function() {
                            return editor === null || editor === void 0 ? void 0 : editor.undo();
                        },
                        redo: function() {
                            return editor === null || editor === void 0 ? void 0 : editor.redo();
                        },
                        download: function() {
                            if (props.isSubscribed) {
                                editor === null || editor === void 0 ? void 0 : editor.download();
                            } else {
                                props.onSubscriptionNeeded();
                            }
                        }
                    })
                })
            })
        ]
    });
}


/***/ })

}]);